import {Box, TextProps} from '@chakra-ui/react';
import {StyledSubheaderText} from 'components/theme/StyledSubheaderText';
import React from 'react';

export interface GeoTextProps extends TextProps {
	isCentered?: boolean;
}

export const GeoSubheaderText: React.FC<GeoTextProps> = (
	props: GeoTextProps
) => (
	<>
		<StyledSubheaderText
			as={props.as}
			fontSize={props.fontSize ?? 'md'}
			color={props.color}
			background={props.background}
			textAlign={props.isCentered ? 'center' : undefined}
		>
			<Box
				as='span'
				bg={
					props.bg ??
					// eslint-disable-next-line react/jsx-indent
					'linear-gradient(180deg, rgba(255, 255, 255, 0) 40%, #d4f3fc 60%)'
				}
			>
				{props.children}
			</Box>
		</StyledSubheaderText>
	</>
);
